<template>
  <div class="sid-select">
    <SidbearSettingsGroup
      title="Text"
      active
    >
      <TiptapSettings :sid="`.--${section.sid}-element`" />
    </SidbearSettingsGroup>

    <SidbearSettingsGroup title="Animations">
      <animations
        :sid="section.uid"
        :animations="animations"
      />
    </SidbearSettingsGroup>
    
    <SidbearSettingsGroup title="Padding & Margins">
      <sid-linked-group
        label="Padding"
        :sid="`.--${section.sid}-element`"
        rule-name="padding"
        :min="0"
        :angles="[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]"
      />

      <sid-linked-group
        label="Margin"
        :sid="`.--${section.sid}-element`"
        rule-name="margin"
        :min="-2000"
        :max="2000"
        :angles="[
          {
            text: '',
            value: 'top'
          },
          {
            text: '',
            value: 'right'
          },
          {
            text: '',
            value: 'bottom'
          },
          {
            text: '',
            value: 'left'
          }
        ]"
      />
    </SidbearSettingsGroup>
  </div>
</template>

<script>
import ModMixin from '@/components/mixins/ModMixin'
import SidLinkedGroup from '@/components/editor/components/sid-controls/SidLinkedGroup.vue'
import SidbearSettingsGroup from '@/components/editor/components/SidbearSettingsGroup.vue'
import Animations from '@/components/editor/controls/Animations.vue'
import TiptapSettings from '@/components/editor/utils/TiptapSettings.vue'

export default {
  name: 'TiptapModV3',
  mixins: [ModMixin],
  components: {
    TiptapSettings,
    Animations,
    SidbearSettingsGroup,
    SidLinkedGroup
  },
  computed: {
    animations: {
      get () {
        if (!Object.prototype.hasOwnProperty.call(this.config, 'animations')) {
          this.$set(this.config, 'animations', {
            animation: null,
            once: true,
            offset: 200,
            delay: 50
          })
        }

        return this.config.animations
      },
      set (val) {
        this.config.animations = val
      }
    }
  }
}
</script>